import { useEffect, useState } from 'react';

/** Bildschirmtastatur offen? (Sichtbarer Bereich deutlich kleiner als das Fenster) */
export function useKeyboardOpen() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;
    // Mit Zoom-Faktor rechnen: Hineinzoomen verkleinert den sichtbaren Bereich auch, ist aber keine Tastatur
    const check = () => setOpen(window.innerHeight - vv.height * vv.scale > 150);
    vv.addEventListener('resize', check);
    return () => vv.removeEventListener('resize', check);
  }, []);
  return open;
}
